import { DesignationTypesEnum } from "enum/DesignationTypesEnum";
import { RoleIdEnum } from "enum/RoleIdEnum";

export const APP_AUTH_CONST = "AuthUser";
export const APP_SIDEBAR_CONST = "miniSideBar";
export const EMAIL_REGX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const baseUrl = process.env.REACT_APP_API_URL + "api/";
export const EmployeeRouteRoleId = [
  RoleIdEnum.HRManager,
  RoleIdEnum.Admin,
  RoleIdEnum.SuperAdmin,
];
export const EmployeeSalaryRouteRoleId = [
  RoleIdEnum.HRManager,
  RoleIdEnum.Admin,
  RoleIdEnum.SuperAdmin,
];
export const PayslipAllowRoleId = [
  RoleIdEnum.HRManager,
  RoleIdEnum.Admin,
  RoleIdEnum.SuperAdmin,
];
export const ContractRouteRoleId = [
  RoleIdEnum.HRManager,
  RoleIdEnum.Admin,
  RoleIdEnum.SuperAdmin,
];
export const OvertimeRouteRoleId = [
  RoleIdEnum.HRManager,
  RoleIdEnum.Admin,
  RoleIdEnum.SuperAdmin,
  RoleIdEnum.Manager,
  RoleIdEnum.Employee,
];
export const AttendanceRouteRoleId = [
  RoleIdEnum.HRManager,
  RoleIdEnum.Admin,
  RoleIdEnum.SuperAdmin,
];
export const ChangePasswordRouteRoleId = [RoleIdEnum.SuperAdmin];
export const AllowAllDayLeaveFromDateRolesId = [
  RoleIdEnum.HRManager,
  RoleIdEnum.Admin,
  RoleIdEnum.SuperAdmin,
];
export const GenerateLeaveRolesId = [
  RoleIdEnum.HRManager,
  RoleIdEnum.Admin,
  RoleIdEnum.SuperAdmin,
];
export const AllLeaveRequestRoleId = [
  RoleIdEnum.HRManager,
  RoleIdEnum.Admin,
  RoleIdEnum.SuperAdmin,
];
export const LeaveBalanceRolesId = [
  RoleIdEnum.HRManager,
  RoleIdEnum.Admin,
  RoleIdEnum.SuperAdmin,
  RoleIdEnum.Employee,
];
export const OnlySuperAdminAllowLeavePermissionRolesId = [
  RoleIdEnum.SuperAdmin,
];
export const AllowApprovedDeclindLeavePermissionRolesId = [
  RoleIdEnum.SuperAdmin,
  RoleIdEnum.Admin,
  RoleIdEnum.HRManager,
  RoleIdEnum.Manager,
];
export const AllowLeaveActionPermissionRoledId = [
  RoleIdEnum.HRManager,
  RoleIdEnum.Admin,
  RoleIdEnum.SuperAdmin,
];
export const AllowDeleteLeaveCommentsRolesId = [RoleIdEnum.SuperAdmin];
export const EmployeeLeaveBalanceRolesId = [RoleIdEnum.Employee];
export const GenerateLeaveCarryForwardRolesId = [
  RoleIdEnum.Admin,
  RoleIdEnum.SuperAdmin,
];
export const SystemFlagForEmployeeRolesId = [RoleIdEnum.Employee];
export const leaveBalanceAlertMessgae =
  "Your Available leave balance is < number of day.";
export const LeaveFromToDateMessage =
  "<li> Less then 8 hours working should be considered as Half Day. </li> <li>  Less then 4 hours working should be considered as Absent.</li> ";
export const CommanListOfDesingnationId = [
  DesignationTypesEnum.BDE,
  DesignationTypesEnum.BDM,
  DesignationTypesEnum.BackEndDeveloper,
  DesignationTypesEnum.FrontEndDeveloper,
  DesignationTypesEnum.FullStackDeveloper,
  DesignationTypesEnum.HRExecutive,
  DesignationTypesEnum.MobileDeveloper,
  DesignationTypesEnum.PHPDeveloper,
  DesignationTypesEnum.ProjectManager,
  DesignationTypesEnum.ProjectTrainee,
  DesignationTypesEnum.SoftwareEngineer,
  DesignationTypesEnum.SrBackEndDeveloper,
  DesignationTypesEnum.SrFrontEndDeveloper,
  DesignationTypesEnum.SrFullStackDeveloper,
  DesignationTypesEnum.SrMobileDeveloper,
  DesignationTypesEnum.SrPHPDeveloper,
  DesignationTypesEnum.SrWebDesigner,
  DesignationTypesEnum.TeamLeader,
  DesignationTypesEnum.Trainee,
  DesignationTypesEnum.UIUXDesigner,
  DesignationTypesEnum.WebDesigner,
  DesignationTypesEnum.SoftwareDeveloper,
  DesignationTypesEnum.SrSoftwareDeveloper,
  DesignationTypesEnum.SrHRExecutive,
  DesignationTypesEnum.WebDeveloper,
  DesignationTypesEnum.SrWebDeveloper,
];
export const ReportsRouterRoleId = [
  RoleIdEnum.HRManager,
  RoleIdEnum.Admin,
  RoleIdEnum.SuperAdmin,
];
export const ResourcesRouterRoleId = [
  RoleIdEnum.HRManager,
  RoleIdEnum.Admin,
  RoleIdEnum.SuperAdmin,
];
export const CommonErrorMessage = "Something is wrong!";
export const GetTotalContractAlertMessage =
  "More then one contract is running, Are you sure you want to continue?";
export const SandwichRuleAlertMessage = "Are you sure to apply sandwich rule?";
export const SandwichRuleAlertMessageForEmployee = "Sandwich rule apply.";
export const SettingRouteRoleId = [
  RoleIdEnum.HRManager,
  RoleIdEnum.Admin,
  RoleIdEnum.SuperAdmin,
];
export const reportsBaseUrl = process.env.REACT_APP_REPORTS_API_URL;
export const CommonSaveInfoMessage = "Are you sure save this information!";
export const ExitEmployeeMessage = "Are you sure to exit this employee!";
export const futureContractSaveAlertMessage =
  "Do you want to create future contract for ";
export const CancelButtonColor = "#d33";
export const ConfirmButtonColor = "#02a4ef";
export const ConfirmButtonText = "Yes, save it";
export const DefaultValue = "N/A";
export const LeaveBalanceConfirmMessage = "Continue";
export const ConfirmNextBtnText = "Next";
export const ConfirmCancelBtnText = "Stay here";
export const ProfileConfirmSaveInfo =
  "Are you sure, update profile information!";
export const DeleteDocumentAlertMessage = "Do you delete contract document?";
export const DeleteDocumentAlertMessageBtnName = "Yes, delete it";
export const UpdateDocumnetAlertMessage = "Update document?";
export const UpdateDocumnetAlertBtnName = "Yes, update it";
export const ImagePdfUploadError = "Please select only image and pdf!";
export const ImageUploadError = "Please select only image!";
export const SandwichRuleAlertConfiremBtn = "Yes";
export const SandwichRuleAlertCancelBtn = "No";
export const SessionError = "Session expired!!";
export const DeleteRecordMessage = "Are you sure you want to delete?";
export const MultipleDeleteRecordMessage = (number: number) => {
  return `Are you sure you want to delete (${number}) records?`;
};
export const SalarySheetMessage = "Are you sure you want to download?";
export const PasswordChangeSuccess = "Password change Successfully";
export const ContractEndDatePermitTag = "contractenddatepermit";
export const ContractEndDatePermitTagValue = "enable";
export const FnfEndDatePermit = "fnfenddatepermit";
export const FnfEndDatePermitTagValue = "enable";
export const FnFSettlementDatePermit = "fnfsettlementdatepermit";
export const FnFSettlementDatePermitTagValue = "enable";
export const fixIncentiveDurationPermit = "fixincentivedurationpermit";
export const SetAllLeavePageSizePermit = "setallleavepagesizepermit";
export const DashbordRouteRoleId = [
  RoleIdEnum.HRManager,
  RoleIdEnum.Admin,
  RoleIdEnum.SuperAdmin,
  RoleIdEnum.Manager,
];
export const FNFEmployeeMessage =
  "Are you sure to full and final settlement save?";
export const RemainingDayAlert = (day: number) => {
  return `Please settle the  ${day} remaining Days`;
};
export const approvedleavesavebtnpermit = "approvedleavesavebtnpermit";
export const probationPeriodNote = "Employee is in probation period";
export const AllowSalaryActionPermissionRoledIdAfterPaid = [
  RoleIdEnum.SuperAdmin,
];
export const AllowHoldSalaryActionPermissionRoledIdAfterPaid = [
  RoleIdEnum.SuperAdmin,
  RoleIdEnum.Admin,
];
export const carryForwardLeavePermitTag = "carryforwardleavepermit";
export const LEAVE_STATE_CONST = "leavesState";
export const EmployeeUpdateContractStatusMessage = (status: string) => {
  return `Are you sure to change the contract <b>${status}</b> ?`;
};
export const biometricBaseUrl = process.env.REACT_APP_BIOMETRIC_API_URL;
export const BIO_AUTH_USER_CONST = "BioAuthUser";
export const basicTag = "basic";
export const hraTag = "hra";
export const ltaTag = "lta";
export const travelTag = "travelallowance";
export const empPf = "empepf";
export const companyPf = "companyepf";
export const empEsic = "empesic";
export const companyEsic = "companyesic";
export const variablePayLowCtc = "variablelowctc";
export const variablePayHighCtc = "variablehighctc";
export const leaveExistsError =
  "Your leave request for the selected date is already under review. Please verify the date.";
export const APP_URL = window.location.origin;
